import React, { useEffect, useState } from "react";
import { useGlobalStore } from "~/store";
import { Case, If, MultiCases } from "~/common/components/If";
import Category from "~/pages/invest/RoundPage/modal/RoundDetailModal/Edit/component/category";
import Short from "~/pages/invest/RoundPage/modal/RoundDetailModal/Edit/component/short";
import Long from "~/pages/invest/RoundPage/modal/RoundDetailModal/Edit/component/long";
import RadioType from "~/pages/invest/RoundPage/modal/RoundDetailModal/Edit/component/radioType";
import Agree from "~/pages/invest/RoundPage/modal/RoundDetailModal/Edit/component/agree";
import Text from "~/pages/invest/RoundPage/modal/RoundDetailModal/Edit/component/text";
import File from "~/pages/invest/RoundPage/modal/RoundDetailModal/Edit/component/file";
import Link from "~/pages/invest/RoundPage/modal/RoundDetailModal/Edit/component/link";
import AddressType from "~/pages/invest/RoundPage/modal/RoundDetailModal/Edit/component/addressType";
import TagType from "~/pages/invest/RoundPage/modal/RoundDetailModal/Edit/component/tagType";
import Date from "~/pages/invest/RoundPage/modal/RoundDetailModal/Edit/component/date";
import "~/assets/sass/pages/invest/round/roundForm.scss";
import useRequest from "~/common/hooks/useRequest";
import Loading from "~/common/components/Loading";
import useAlert from "~/common/hooks/useAlert";
import SelectType from "~/pages/invest/RoundPage/modal/RoundDetailModal/Edit/component/selectType";
import { useTranslation } from "react-i18next";
import MultiSelectType from "~/pages/invest/RoundPage/modal/RoundDetailModal/Edit/component/multiSelectType";
import {certTypeSelect} from "~/common/constants/type";

const FormCards = ({ useForm, survey, apply, companyInfoData }) => {
	const [companyTypeSel, setCompanyTypeSel] = useState(""); // 기업구분이 예비창업일때 사업자등록번호 비활성화 하기위함

	function setOptions(options) {
		let newOptions = [];
		options.forEach((option) => {
			newOptions.push({ label: option.title, value: option.title });
		});

		return newOptions;
	}

	const setCompanyInfoValue = (form, useForm, formContent) => {
		if(formContent === "companyName" || formContent === "name") {
			// 기업명 - 이름과 key값이 달라서 예외처리
			if(companyInfoData.company.name) {
				useForm.setValue(form.order.toString(), companyInfoData.company.name)
			}
		} else if(formContent === "regNum") {
			// 기업명 - 이름과 key값이 달라서 예외처리
			if(companyInfoData.company.regNum) {
				useForm.setValue(form.order.toString(), companyInfoData.company.regNum)
			}
		} else if(formContent === "address" || formContent === "addressDetail" || formContent === "zipCode") {
			// 주소 - 이름과 key값이 달라서 예외처리
			useForm.setValue(form.order.toString() + "/zipCode", companyInfoData.company.zipCode);
			useForm.setValue(form.order.toString() + "/address", companyInfoData.company.address);
			useForm.setValue(form.order.toString() + "/addressDetail", companyInfoData.company.addressDetail);
		} else if(formContent === "fields") {
			const transferData = companyInfoData.company.CompanyField.map((option) => ({label: option.idx, value: option.field}));
			useForm.setValue(form.order.toString(), transferData)
		} else if(companyInfoData.company[`${formContent}`]) {
			useForm.setValue(form.order.toString(), companyInfoData.company[`${formContent}`])
		}
	}

	return survey.map((form, f_idx) => (
		<If condition={form.type} {...{ useForm, form, apply, companyInfoData, setCompanyInfoValue }} key={f_idx}>
			<Case condition={"CATEGORY"}>
				<Category />
			</Case>
			<Case condition={"SHORT"}>
				<Short companyTypeSel={companyTypeSel} />
			</Case>
			<Case condition={"LONG"}>
				<Long />
			</Case>
			<MultiCases condition={["CHOICE", "ALTERNATIVE"]}>
				<RadioType {...{ setOptions }} />
			</MultiCases>
			<Case condition={"AGREE"}>
				<Agree />
			</Case>
			<Case condition={"TEXT"}>
				<Text />
			</Case>
			<Case condition={"FILE"}>
				<File />
			</Case>
			<Case condition={"LINK"}>
				<Link />
			</Case>
			<Case condition={"ADDRESS"}>
				<AddressType />
			</Case>
			<Case condition={"TAG"}>
				<TagType />
			</Case>
			<Case condition={"DATE"}>
				<Date />
			</Case>
			<Case condition={"SELECT"}>
				<SelectType setCompanyTypeSel={setCompanyTypeSel} />
			</Case>
			<Case condition={"MULTISELECT"}>
				<MultiSelectType />
			</Case>
		</If>
	));
};


const Edit = ({ setModalToggle, getRoundList, filteredData, surveyForm, viewInfoPage, companyInfoData }) => {
	const { t } = useTranslation();
	const [
		{
			round: {
				info: { idx, apply },
				survey,
			},
		},
	] = useGlobalStore();

	const [loading, setLoading] = useState(true);

	useEffect(() => {
		survey && survey.length !== 0 && setLoading(false);
	}, [survey]);

	const roundApplyMutation = useRequest("post", "round/apply");

	const submit = async (data) => {
		showSubmitAlert().then(() => onSubmit(filteredData(data)));
	};


	const regNumCheck = (newData) => {
		let check = true;
		newData.map(item => {
			if(item.content === "type") {
				if(item.answer !== "예비 창업") {
					const bizNum = newData.filter(it => it.content === "regNum")?.[0]?.answer;
					if(bizNum === "0000000000") {
						check = false;
					}
				}
			}
		});
		return check;
	}

	const onSubmit = (newData) => {
		// const submitData = newData.map((d) => ({
		// 	...d,
		// 	answer: d.type === "FILE" ? JSON.stringify(d.answer) : d.answer,
		// }));
		// 예비창업 아닐때 0000000000 값 입력 막기

		if(regNumCheck(newData)) {
			// 라운드 등록전 데이터 확인
			const fixData = newData.map(item => {
				if(item.title === "사업자등록번호") {
					return({
						...item,
						answer: item.answer.replaceAll("-", "")
					})
				}
				if(item.content === "fields") {
					return ({
						isCompanyData: item.isCompanyData,
						selectOption: item.selectOption,
						type: item.type,
						title: item.title,
						content: item.content,
						required: item.required,
						defaultDataType: item.defaultDataType,
						order: item.order,
						answer: item.answer.map(item => (item.value))
					})
				} else {
					return ({
						isCompanyData: item.isCompanyData,
						selectOption: item.selectOption,
						type: item.type,
						title: item.title,
						content: item.content,
						required: item.required,
						defaultDataType: item.defaultDataType,
						order: item.order,
						answer: item.answer
					})
				}
			});
			roundApplyMutation
				.asyncCall({ roundIdx: idx, result: fixData })
				.then(() => {
					setModalToggle(false);
					getRoundList();
				})
				.catch((e) => {
					console.log("error:", e);
					setErrorMsg(e.message)
					showErrorAlert();
				});
		} else {
			showWarningAlert();
		}
	};

	// 사업자 등록번호 예외
	const [showWarningAlert, WarningAlert] = useAlert();
	//
	const [showErrorAlert, ErrorAlert] = useAlert();
	const [showSubmitAlert, SubmitAlert] = useAlert();
	const [errorMsg, setErrorMsg] = useState("");



	const [roundTitle] = useState(survey ? survey.find((d) => d.type === "TITLE") ?? "" : "");

	return (
		<>
			<If condition={loading}>
				<Case condition={true}>
					<Loading />
				</Case>
				<Case condition={false}>
					<div className="modal-content round-form">
						<div className="round-form-head">
							<b>{t("Invest.Round.RoundDetailModal.Edit.round-form-head.b")}</b>
							<div className="round-title">
								<h3>{roundTitle.title}</h3>
								<p>{roundTitle.content}</p>
							</div>
						</div>
						<FormCards useForm={surveyForm} {...{ survey, apply, companyInfoData }} />
					</div>
				</Case>
			</If>
			<div className="modal-footer">
				{apply ? (
					<button
						type="button"
						className="btn__solid"
						color="gray"
						onClick={() => setModalToggle(false)}
					>
						{t("button.check")}
					</button>
				) : (
					<>
						<button
							type="button"
							className="btn__solid"
							color="gray"
							onClick={viewInfoPage}
						>
							{t("button.back")}
						</button>
						<button
							type="button"
							className="btn__solid"
							color="primary"
							id="round_submit"
							onClick={surveyForm.handleSubmit(submit)}
						>
							{t("button.Submit")}
						</button>
					</>
				)}
			</div>
			<ErrorAlert message={errorMsg} type="error" confirm={t("button.check")} />
			<WarningAlert message={"잘못된 사업자 번호 입니다."} type="error" confirm={t("button.check")} />
			<SubmitAlert
				message={
					<>
						<h3>{t("Invest.Round.RoundDetailModal.Edit.SubmitAlert.h3")}</h3>
						<p>{t("Invest.Round.RoundDetailModal.Edit.SubmitAlert.p")}</p>
					</>
				}
				layout={"horiz"}
				type="warning"
				confirm={t("button.check")}
				reject={t("button.cancel")}
			/>
		</>
	);
};

export default Edit;
